import BaseCRUDService from '../BaseCRUDService';

class LogsService extends BaseCRUDService {
  getBaseURL = () => {
    return '~/api/manager/logs';
  };
}

export default new LogsService();
